import { Box, Grid, Typography } from "@mui/material";
import CustomCopyButton from "../../../../../../components/CustomCopyButton";
import { NHIType } from "../../../../../../utils/constants";
import { NHITypeIconsAndLabels } from "../../../utils";
import TextIntegrationStyle from "../../TextIntegrationStyle";

const AzureKeyVaultResourceDetailsView = ({ entityData, children }) => {
  const typeKeyVaultLogo = (type) => {
    if (Object.keys(NHITypeIconsAndLabels).includes(type)) {
      const [icon] = NHITypeIconsAndLabels[type];
      return icon;
    }
    return null;
  };

  const typeKeyVaultLabel = (type) => {
    if (Object.keys(NHITypeIconsAndLabels).includes(type)) {
      const [, label] = NHITypeIconsAndLabels[type];
      return label;
    }
    return null;
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {entityData?.subtype && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <Typography variant="subtitle2">Type</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={typeKeyVaultLabel(entityData.subtype)}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.azure_keyvault_resource_data?.enabled !== undefined && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <Typography variant="subtitle2">Status</Typography>
          </Box>
          <Box ml={2} display="flex" alignItems="center" gap={0.5}>
            <Box display="flex" alignItems="center" gap={0.5}>
              <TextIntegrationStyle
                title=""
                value={
                  entityData.azure_keyvault_resource_data.enabled
                    ? "Enabled"
                    : "Disabled"
                }
              />
            </Box>
          </Box>
        </Box>
      )}
      {entityData?.azure_keyvault_resource_data?.resource_type !==
        NHIType.AZURE_KEYVAULT_CERTIFICATE && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <Typography variant="subtitle2">Managed By Azure</Typography>
          </Box>
          <Box ml={2} display="flex" alignItems="center" gap={0.5}>
            <TextIntegrationStyle
              title=""
              value={
                entityData?.azure_keyvault_resource_data?.managed
                  ? "True"
                  : "False"
              }
            />
          </Box>
        </Box>
      )}

      {entityData?.azure_keyvault_resource_data?.firewall_enabled !==
        undefined && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <Typography variant="subtitle2">Firewall Enabled</Typography>
          </Box>
          <Box ml={2} display="flex" alignItems="center" gap={0.5}>
            <TextIntegrationStyle
              title=""
              value={
                entityData.azure_keyvault_resource_data.firewall_enabled
                  ? "True"
                  : "False"
              }
            />
          </Box>
        </Box>
      )}
      {children}
      {entityData?.azure_keyvault_resource_data?.subscription_name && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <Typography variant="subtitle2">Subscription Name</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={
                entityData?.azure_keyvault_resource_data?.subscription_name
              }
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.azure_keyvault_resource_data?.resource_group_name && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <Typography variant="subtitle2">Resource Group</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={
                entityData?.azure_keyvault_resource_data?.resource_group_name
              }
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.azure_keyvault_resource_data?.vault_name && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <Typography variant="subtitle2">Vault Name</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={entityData?.azure_keyvault_resource_data?.vault_name}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.azure_keyvault_resource_data?.location && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <Typography variant="subtitle2">Location</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={entityData.azure_keyvault_resource_data.location}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.azure_keyvault_resource_data?.resource_id && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <Typography variant="subtitle2">Resource ID</Typography>
          </Box>
          <Box ml={2} display="flex">
            <Grid container gap={2} direction="row">
              <Grid item xs={8}>
                <TextIntegrationStyle
                  title=""
                  value={entityData.azure_keyvault_resource_data.resource_id}
                ></TextIntegrationStyle>
              </Grid>
              <Grid item xs={3}>
                <CustomCopyButton
                  copyTitle="Resource ID"
                  copyText={entityData.azure_keyvault_resource_data.resource_id}
                />
              </Grid>
            </Grid>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default AzureKeyVaultResourceDetailsView;
